
const isLocalNetwork = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';

const backendDomain = process.env.NODE_ENV === 'development'
    ? (isLocalNetwork ? `http://${window.location.hostname}:5000` : "http://localhost:5000")
    : process.env.NODE_ENV === 'production'
        // ? "https://naach-boutique.onrender.com"   // Use the production API in production environment
        ? "https://kl-property-live.onrender.com"
        : "http://192.168.0.1:5000";


const SummaryApi = {

    // ===================== ENQUIRY ROUTES =====================
    createEnquiry: {
        url: `${backendDomain}/api/enquiries/create`,
        method: "post"
    },

    // ===================== PROPERTY ROUTES =====================
    getAllProperties: {
        url: `${backendDomain}/api/property/view-all`,
        method: "get"
    },
    getOneProperty: {
        url: (propertyId) => `${backendDomain}/api/property/view-one/${propertyId}`,
        method: "get"
    },
    homeCategoryPreview: {
        url: `${backendDomain}/api/property/category-preview`,
        method: "get"
    },

    // ===================== BANNERS ROUTES =====================

    getAllBanners: {
        url: `${backendDomain}/api/banners/view-all`,
        method: "get"
    },

    // ===================== TESTIMONIALS ROUTES =====================
    getAllTestimonials: {
       url: `${backendDomain}/api/testimonial/view-all`,
       method: "get"
    },

    // ===================== GALLERY ROUTES =====================
    getAllGallery: {
        url: `${backendDomain}/api/media/view-all`,
        method: "get"
    }
};

export default SummaryApi;